import React from 'react'
import AdminReservations from '../../components/admin/reservations/admin-reservations'
import AdminTemplate from '../../templates/admin-template'


const AdminReservationsPage = () => {
  return (
    <AdminTemplate>
        <AdminReservations/>
    </AdminTemplate>
  )
}

export default AdminReservationsPage